import React from 'react';
import { useIntl } from 'react-intl';

import { Button, FontSizes, FontWeights, Text } from '@calm-web/design-system';

import { useEmotionDetectorContext } from '@/components/emotion-detector/EmotionDetectorContextProvider';
import EmotionDetectorFooter from '@/components/emotion-detector/EmotionDetectorFooter';
import EmotionDetectorHeader from '@/components/emotion-detector/EmotionDetectorHeader';
import messages from '@/components/emotion-detector/messages';

import {
	ButtonGrid,
	GradientTitle,
	HelpBox,
	HelpText,
	HeroDescription,
	HeroSection,
	PageContainer,
	QuestionTitle,
	StyledCard,
} from './styles';

export default function HomeScreen() {
	const { formatMessage } = useIntl();
	const { setActiveScreen } = useEmotionDetectorContext();

	return (
		<>
			<EmotionDetectorHeader currentPage="home" />
			<PageContainer>
				<StyledCard>
					<HeroSection>
						<GradientTitle>
							<Text el="h1" size={FontSizes['4xl']} weight={FontWeights.Demi}>
								{formatMessage(messages.homeHeroTitle)}
							</Text>
						</GradientTitle>
						<HeroDescription>
							<Text el="p" size={FontSizes.lg}>
								{formatMessage(messages.homeHeroDescription)}
							</Text>
						</HeroDescription>
					</HeroSection>

					<QuestionTitle>
						<Text el="h2" size={FontSizes['2xl']} weight={FontWeights.Medium}>
							{formatMessage(messages.question)}
						</Text>
					</QuestionTitle>

					<ButtonGrid>
						<Button
							fullWidth
							backgroundColor="accessibleBrandGradient"
							onPress={() => setActiveScreen('camera')}
						>
							📸 {formatMessage(messages.openDetector)}
						</Button>

						<Button
							fullWidth
							backgroundColor="accessibleBrandGradient"
							onPress={() => setActiveScreen('log')}
						>
							📔 {formatMessage(messages.openLog)}
						</Button>
					</ButtonGrid>

					<HelpBox>
						<HelpText>
							<Text el="p" size={FontSizes.sm}>
								{formatMessage(messages.homeHelpText)}
							</Text>
						</HelpText>
					</HelpBox>
				</StyledCard>
			</PageContainer>
			<EmotionDetectorFooter />
		</>
	);
}
